(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-collection-pro"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__fcrInit) return;
    window.__fcrInit = true;

    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function updateArrows(wrap) {
      var track = wrap.querySelector('[data-fcr-track]');
      if (!track) return;
      var prev = wrap.querySelector('[data-fcr-arrow="-1"]');
      var next = wrap.querySelector('[data-fcr-arrow="1"]');
      if (!prev || !next) return;
      var overflow = track.scrollWidth - track.clientWidth > 4;
      if (prev.parentElement) prev.parentElement.style.visibility = overflow ? '' : 'hidden';
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
    }
    function updateAll() {
      document.querySelectorAll('[data-fcr].fcr--carousel').forEach(updateArrows);
    }

    document.addEventListener('click', function (e) {
      var arrow = e.target.closest('[data-fcr-arrow]');
      if (arrow) {
        var wrap = arrow.closest('[data-fcr]');
        var track = wrap.querySelector('[data-fcr-track]');
        var card = track.querySelector('.fcr-card');
        if (!card) return;
        var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        var step = card.getBoundingClientRect().width + gap;
        var visible = Math.max(1, Math.floor(track.clientWidth / step));
        track.scrollBy({ left: Number(arrow.dataset.fcrArrow) * step * visible, behavior: reduceMotion ? 'auto' : 'smooth' });
        return;
      }
      var btn = e.target.closest('[data-fcr-add]');
      if (btn) { e.preventDefault(); addToCart(btn); }
    });

    document.addEventListener('scroll', function (e) {
      var t = e.target;
      if (t && t.matches && t.matches('[data-fcr-track]')) updateArrows(t.closest('[data-fcr]'));
    }, { capture: true, passive: true });

    window.addEventListener('resize', updateAll, { passive: true });
    window.addEventListener('load', updateAll);
    document.addEventListener('DOMContentLoaded', updateAll);
    document.addEventListener('shopify:section:load', updateAll);
    updateAll();

    function setLabel(btn, text) {
      var l = btn.querySelector('.fcr-btn__label');
      if (l) l.textContent = text;
    }

    function updateIconBubble(data) {
      try {
        if (!data.sections || !data.sections['cart-icon-bubble']) return;
        var doc = new DOMParser().parseFromString(data.sections['cart-icon-bubble'], 'text/html');
        var src = doc.querySelector('.shopify-section') || doc.body;
        var target = document.getElementById('cart-icon-bubble');
        if (target) target.innerHTML = src.innerHTML;
      } catch (err) {}
    }

    function openDrawer(data) {
      var drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.renderContents === 'function') {
        drawer.renderContents(data);
        return true;
      }
      ['cart:refresh', 'cart:updated', 'cart:build', 'theme:cart:reload'].forEach(function (n) {
        document.dispatchEvent(new CustomEvent(n, { bubbles: true, detail: { cart: data } }));
      });
      var trigger = document.querySelector('[data-cart-drawer-trigger], [data-cart-toggle], #cart-icon-bubble, button[aria-controls*="cart" i], a[href$="/cart"][aria-haspopup]');
      if (trigger) { trigger.click(); return true; }
      return false;
    }

    async function addToCart(btn) {
      if (btn.disabled) return;
      var wrap = btn.closest('[data-fcr]');
      var action = wrap.dataset.cartAction;
      var drawer = document.querySelector('cart-drawer');
      var original = btn.dataset.label || '';

      btn.disabled = true;
      btn.classList.add('is-loading');

      var payload = { id: Number(btn.dataset.variantId), quantity: 1 };
      if (drawer && typeof drawer.getSectionsToRender === 'function') {
        payload.sections = drawer.getSectionsToRender().map(function (s) { return s.id; }).join(',');
        payload.sections_url = window.location.pathname;
      }

      try {
        var res = await fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify(payload)
        });
        var data = await res.json();
        if (!res.ok || data.status) throw new Error(data.description || data.message || 'Could not add');

        if (action === 'redirect') { window.location.href = root + 'cart'; return; }
        if (action === 'drawer') {
          if (!openDrawer(data)) { window.location.href = root + 'cart'; return; }
        } else {
          updateIconBubble(data);
        }
        setLabel(btn, 'Added');
      } catch (err) {
        setLabel(btn, (err && err.message && err.message.length < 40) ? err.message : 'Try again');
      } finally {
        btn.classList.remove('is-loading');
        setTimeout(function () { btn.disabled = false; setLabel(btn, original); }, 1800);
      }
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shopable-video-card"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__vcInit) return;
    window.__vcInit = true;

    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var saveData = navigator.connection && navigator.connection.saveData;
    var canAutoplay = !reduce && !saveData && 'IntersectionObserver' in window;
    var inView = new Set();
    var loadIO = null;
    var playIO = null;

    /* ---------- Video: load near viewport, play only while visible ---------- */
    function loadVideo(v) {
      if (v.dataset.loaded || !v.dataset.src) return;
      v.dataset.loaded = '1';
      v.preload = 'metadata';
      v.src = v.dataset.src;
    }
    function playVideo(v) {
      if (!canAutoplay) return;
      loadVideo(v);
      v.muted = true;
      var p = v.play();
      if (p && p.catch) p.catch(function () {});
    }
    function pauseVideo(v) {
      if (!v.paused) v.pause();
    }

    if (canAutoplay) {
      loadIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          loadVideo(e.target);
          loadIO.unobserve(e.target);
        });
      }, { rootMargin: '300px 0px' });

      playIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          var v = e.target;
          if (!v.isConnected) { playIO.unobserve(v); inView.delete(v); return; }
          if (e.intersectionRatio >= 0.4) {
            inView.add(v);
            if (!document.hidden) playVideo(v);
          } else {
            inView.delete(v);
            pauseVideo(v);
          }
        });
      }, { threshold: [0, 0.4, 0.6] });
    }

    document.addEventListener('playing', function (e) {
      var v = e.target;
      if (v && v.classList && v.classList.contains('vc-video')) v.classList.add('is-playing');
    }, true);

    document.addEventListener('visibilitychange', function () {
      inView.forEach(function (v) { document.hidden ? pauseVideo(v) : playVideo(v); });
    });

    function initVideos(scope) {
      if (!canAutoplay) return;
      (scope || document).querySelectorAll('.vc-video').forEach(function (v) {
        if (v.__vc) return;
        v.__vc = true;
        v.muted = true;
        loadIO.observe(v);
        playIO.observe(v);
      });
    }

    /* ---------- Carousel arrows (desktop carousel option) ---------- */
    function updateArrows(wrap) {
      var track = wrap.querySelector('[data-vc-track]');
      var prev = wrap.querySelector('[data-vc-arrow="-1"]');
      var next = wrap.querySelector('[data-vc-arrow="1"]');
      if (!track || !prev || !next) return;
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
    }
    function updateAllArrows() {
      document.querySelectorAll('[data-vc].vc--carousel').forEach(updateArrows);
    }

    document.addEventListener('click', function (e) {
      var arrow = e.target.closest('[data-vc-arrow]');
      if (arrow) {
        var wrap = arrow.closest('[data-vc]');
        var track = wrap.querySelector('[data-vc-track]');
        var card = track.querySelector('.vc-card');
        if (!card) return;
        var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        var step = card.getBoundingClientRect().width + gap;
        track.scrollBy({ left: Number(arrow.dataset.vcArrow) * step * Math.max(1, Math.floor(track.clientWidth / step)), behavior: reduce ? 'auto' : 'smooth' });
        return;
      }
      var btn = e.target.closest('[data-vc-add]');
      if (btn) { e.preventDefault(); addToCart(btn); }
    });
    document.addEventListener('scroll', function (e) {
      var t = e.target;
      if (t && t.matches && t.matches('[data-vc-track]')) updateArrows(t.closest('[data-vc]'));
    }, { capture: true, passive: true });
    window.addEventListener('resize', updateAllArrows, { passive: true });

    function boot() { initVideos(document); updateAllArrows(); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
    window.addEventListener('load', boot);
    document.addEventListener('shopify:section:load', function (e) { initVideos(e.target); updateAllArrows(); });
    document.addEventListener('shopify:block:select', function (e) { initVideos(e.target); });

    /* ---------- Add to cart + drawer ---------- */
    function setLabel(btn, text) {
      var l = btn.querySelector('.vc-btn__label');
      if (l) l.textContent = text;
    }
    function updateIconBubble(data) {
      try {
        if (!data.sections || !data.sections['cart-icon-bubble']) return;
        var doc = new DOMParser().parseFromString(data.sections['cart-icon-bubble'], 'text/html');
        var src = doc.querySelector('.shopify-section') || doc.body;
        var target = document.getElementById('cart-icon-bubble');
        if (target) target.innerHTML = src.innerHTML;
      } catch (err) {}
    }
    function openDrawer(data) {
      var drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.renderContents === 'function') { drawer.renderContents(data); return true; }
      ['cart:refresh', 'cart:updated', 'cart:build', 'theme:cart:reload'].forEach(function (n) {
        document.dispatchEvent(new CustomEvent(n, { bubbles: true, detail: { cart: data } }));
      });
      var trigger = document.querySelector('[data-cart-drawer-trigger], [data-cart-toggle], #cart-icon-bubble, button[aria-controls*="cart" i], a[href$="/cart"][aria-haspopup]');
      if (trigger) { trigger.click(); return true; }
      return false;
    }
    async function addToCart(btn) {
      if (btn.disabled) return;
      var wrap = btn.closest('[data-vc]');
      var action = wrap.dataset.cartAction;
      var drawer = document.querySelector('cart-drawer');
      var original = btn.dataset.label || '';
      btn.disabled = true;
      btn.classList.add('is-loading');

      var payload = { id: Number(btn.dataset.variantId), quantity: 1 };
      if (drawer && typeof drawer.getSectionsToRender === 'function') {
        payload.sections = drawer.getSectionsToRender().map(function (s) { return s.id; }).join(',');
        payload.sections_url = window.location.pathname;
      }
      try {
        var res = await fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify(payload)
        });
        var data = await res.json();
        if (!res.ok || data.status) throw new Error(data.description || data.message || 'Could not add');
        if (action === 'redirect') { window.location.href = root + 'cart'; return; }
        if (action === 'drawer') {
          if (!openDrawer(data)) { window.location.href = root + 'cart'; return; }
        } else {
          updateIconBubble(data);
        }
        setLabel(btn, 'Added');
      } catch (err) {
        setLabel(btn, (err && err.message && err.message.length < 40) ? err.message : 'Try again');
      } finally {
        btn.classList.remove('is-loading');
        setTimeout(function () { btn.disabled = false; setLabel(btn, original); }, 1800);
      }
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
